export const toolsListConstants = [
    {
        icon: 'mdi-home',
        name: 'Tools',
    },
    {
        icon: 'mdi-code-json',
        name: 'JSON Pretty'
    },
    {
        icon: 'mdi-table-arrow-right',
        name: 'Base 64 Encode-Decode',
    },
    {
        icon: 'mdi-sitemap',
        name: 'Sitemap Analyzer',
    },
    {
        icon: 'mdi-web',
        name: 'Webpage Analyzer',
    },
    {
        icon: 'mdi-code-json',
        name: 'JSON Path',
    },
    {
        icon: 'mdi-identifier',
        name: 'UUID Generator',
    },
    {
        icon: 'mdi-qrcode',
        name: 'QR Code Generator',
    },
    {
        icon: 'mdi-database-edit',
        name: 'SQL Formatter',
    },
    {
        icon: 'mdi-lastpass',
        name: 'Password Generator',
    },
    {
        icon: 'mdi-spider-web',
        name: 'Url Encoder',
    },
    {
        icon: 'mdi-av-timer',
        name: 'Timestamp Converter',
    },
    {
        icon: 'mdi-math-norm',
        name: 'Normalizer',
    },
    {
        icon: 'mdi-login',
        name: 'JWT Debugger',
    },
    {
        icon: 'mdi-file-download',
        name: 'File Converter',
    },
    {
        icon: 'mdi-table',
        name: 'Data Table',
    },
    {
        icon: 'mdi-lightbulb',
        name: 'ExplanationUI',
    },
    {
        icon: 'mdi-lightbulb',
        name: 'QSF Explain UI',
    },
    {
        icon: 'mdi-graph',
        name: 'QSF Explain Graph',
    }
    
];

